export default __webpack_public_path__ + "config_panel_logo.9f5bd3c7.png";